export default "__VITE_ASSET__C9cOlIK5__"